import {useGoogleLogin} from '@react-oauth/google';
import associateServices from "../../../services";
import SESSION_HELPER from "../../../helpers/session-helper";
import {toast} from "react-toastify";
import store from "../../../reducers/createReducers";
import AUTHENTICATION_ACTIONS from "../../../actions/authentication-actions";
import {useTranslation} from "react-i18next";
import SvgIcon from "../../../components/svg-icon";

const RegisterSocialAuthGoogle = props => {

    const {t} = useTranslation()
    const {setLoading, handleClose, settings} = props

    const loginWithGoogle = useGoogleLogin({
        onSuccess: async (tokenResponse) => {
            console.log('tokenResponse.access_token = ', tokenResponse.access_token)

            setLoading(true)
            associateServices.authGoogle({
                token: tokenResponse.access_token,
                agent: SESSION_HELPER.getUserAgent(),

            }).then(handleRegisterResponse)
        },
    });

    const handleRegisterResponse = response => {
        if (response?.status !== 200 || response?.errors) {
            toast.error(t(`api-notifications.${response?.errors}`))
            return setLoading(false)
        }

        store.dispatch(AUTHENTICATION_ACTIONS.setUserToken(response?.data))
        setLoading(false)
        return handleClose()
    }

    return (
        settings?.google_able &&
        <a onClick={() => loginWithGoogle()}>
            <SvgIcon id={'google'}/>
        </a>
    )

}

export default RegisterSocialAuthGoogle;

